export default __webpack_public_path__ + "static/media/title_ko_pc@2x.568fb18d.png";